import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import confetti from "canvas-confetti";
import "./OrderConfirmation.css";

const OrderConfirmation = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Trigger confetti animation
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
    });

    // Fetch order details
    const fetchOrder = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user) {
          navigate("/login");
          return;
        }
        const response = await fetch(`https://kothari-international-server.onrender.com/api/orders/${user.id}`);
        if (!response.ok) {
          throw new Error("Failed to fetch orders");
        }
        const orders = await response.json();
        const foundOrder = orders.find(o => o.order_id === orderId);
        setOrder(foundOrder);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching order:", error);
        setLoading(false);
      }
    };
    fetchOrder();
  }, [orderId, navigate]);

  if (loading) return <p>Loading...</p>;
  if (!order) return <p>Order not found</p>;

  return (
    <div className="order-confirmation">
      <h1>Congratulations! Your Order is Confirmed!</h1>
      <div className="order-details">
        <h2>Order ID: {order.order_id}</h2>
        <p><strong>Payment Method:</strong> {order.payment_method}</p>
        {order.razorpay_payment_id && (
          <p><strong>Transaction ID:</strong> {order.razorpay_payment_id}</p>
        )}
        <p><strong>Total Amount:</strong> ₹{order.total_amount}</p>
        <h3>Items:</h3>
        {order.items.map((item) => (
          <div key={item.id} className="order-item">
            <img src={item.image} alt={item.name} />
            <div>
              <h4>{item.name}</h4>
              <p>₹{item.price} x {item.quantity}</p>
            </div>
          </div>
        ))}
      </div>
      <button
        className="all-orders-btn"
        onClick={() => navigate("/orders")}
      >
        View All Orders
      </button>
    </div>
  );
};

export default OrderConfirmation;